module.exports = __webpack_public_path__ + "media/img/icons/info-ce266592e0873b8fc8371e195e64fa23.png";